module.exports = __webpack_public_path__ + "img/Paladin-human-f-70.2e3be87d.gif";